module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/z8AfuJ/tc-custom/9781429916240.jpg?1737748695835",
      "alt": "This image is the cover for the book School of Fortune"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("School of Fortune\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("A fun, fresh frolic of a novel starring a spoiled but lovable Texas heiress out to reclaim her fortune")]), _c('br'), _c('br'), _vm._v("Pippa Walker's wedding was to be huge—"), _c('i', [_vm._v("Texas")]), _vm._v(" huge—complete with twelve bridesmaids under contract from Pippa's mother to stay lean and long-haired, gondolas flown in from Venice, A- and B- guest lists. But when Pippa finds out her handsome husband-to-be isn't what she thought, she bolts from her own wedding, shocking society and getting herself disinherited. The only way she can get a piece of the family fortune back is to earn a degree from a school. "), _c('i', [_vm._v("Any")]), _vm._v(" school. It's a tough assignment for a girl who dropped out of SMU after pledging Kappa Kappa Gamma and shopping at Neiman's for a year."), _c('br'), _c('br'), _vm._v("But Pippa is nothing if not up for a challenge. Attracting one hilarious misadventure after another, she tries to earn her sheepskin at: driving school, matchmaking school, even a circus academy. It's only when she hits rock-bottom—The Mountbatten Savoy School of Household Management—that things begin to look up. But can she really be falling in love with a…valet?"), _c('br'), _c('br'), _vm._v("\"Great, silly fun, guaranteed to be seen at a beach near you.\" - "), _c('i', [_vm._v("Kirkus Reviews")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Amanda Brown, Janice Weber\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    St. Martin’s Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0